import { render, staticRenderFns } from "./ClassifyList.vue?vue&type=template&id=40b6afb9&scoped=true"
import script from "./ClassifyList.vue?vue&type=script&lang=js"
export * from "./ClassifyList.vue?vue&type=script&lang=js"
import style0 from "./ClassifyList.vue?vue&type=style&index=0&id=40b6afb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b6afb9",
  null
  
)

export default component.exports